"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SellPieceButton = SellPieceButton;
const React = __importStar(require("react"));
const models_1 = require("@creature-chess/models");
const react_jss_1 = require("react-jss");
const react_redux_1 = require("react-redux");
const BalanceIcon_1 = require("~/components/ui/icon/BalanceIcon");
const sessionContext_1 = require("~/game/sessionContext");
const networking_1 = require("~/networking");
const creatureDefinitions_1 = require("~/networking/creatureDefinitions");
const models_2 = require("@creature-chess/models");
const models_3 = require("@creature-chess/models");
const colors_1 = require("./colors");
const ui_1 = require("@creature-chess/ui");
const useStyles = (0, react_jss_1.createUseStyles)({
    balanceIcon: {
        color: colors_1.COLOR_READY_BUTTON_TEXT,
    },
});
function SellPieceButton() {
    var _a, _b;
    const gameActions = (0, networking_1.useGameActions)();
    const styles = useStyles();
    const gamePhase = (0, react_redux_1.useSelector)((state) => state.game.roundInfo.phase);
    const selectedPieceId = (0, react_redux_1.useSelector)((state) => state.game.ui.selectedPieceId);
    const { pieceRegistry } = (0, sessionContext_1.useGameSession)();
    const selectedPiece = React.useMemo(() => {
        if (gamePhase !== models_2.GamePhase.PREPARING || !selectedPieceId) {
            return null;
        }
        return pieceRegistry.getPieceById(selectedPieceId);
    }, [gamePhase, selectedPieceId, pieceRegistry]);
    const onSell = React.useCallback(() => {
        if (!selectedPiece) {
            return;
        }
        gameActions.sellPiece(selectedPiece.id);
    }, [gameActions, selectedPiece]);
    if (!selectedPiece) {
        return null;
    }
    const piecesUsed = (0, models_1.getPiecesForStage)(selectedPiece.stage, models_3.PIECES_TO_EVOLVE);
    const pieceCost = (_b = (_a = (0, creatureDefinitions_1.getCreatureDefinitionById)(selectedPiece.definitionId)) === null || _a === void 0 ? void 0 : _a.cost) !== null && _b !== void 0 ? _b : 0;
    return (React.createElement(ui_1.Button, { color: "secondary", size: "small", onClick: onSell },
        "Sell\u00A0-\u00A0",
        React.createElement(BalanceIcon_1.BalanceIcon, { amount: pieceCost * piecesUsed, className: styles.balanceIcon })));
}
